import type { MediaGrid } from '@ps/web-martech-cms-types';
import React from 'react';

import { CMSHeading, CMSReference } from '@swf/cms';

import styles from './CMSMediaGrid.scss';

const CMSMediaGrid: React.FC<MediaGrid> = ({ items }) => (
  <>
    {items.map(({ item }, index) => (
      <article key={index} className={styles.mediaGridItem}>
        {item.media.map((mediaItem, mediaItemIndex) => (
          <CMSReference key={mediaItemIndex} {...mediaItem} />
        ))}
        <div className={styles.textWrapper}>
          <CMSHeading
            level="h3"
            title={item.title}
            className={styles.heading}
            size="s"
            hero={false}
          />
          {item.body.map((bodyItem, bodyItemIndex) => (
            <CMSReference key={bodyItemIndex} {...bodyItem} />
          ))}
        </div>
      </article>
    ))}
  </>
);

export default CMSMediaGrid;
